import { createStore } from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import auth from './modules/auth'
import headerParam from './modules/headerParam'
import deliveryMonth from './modules/deliveryMonth'
import agency from './modules/agency'
import advertiser from './modules/advertiser'
import creativeReport from './modules/creativeReport'
import cpmCreativeReport from './modules/cpmCreativeReport'
import campaignReport from './modules/campaignReport'
import period from './modules/period'
import report from './modules/report'
import digestive from './modules/digestive'
import campaignDeliveryStatus from './modules/campaignDeliveryStatus'
import campaignList from './modules/campaignList'
import creativeSetting from './modules/creativeSetting'
import bundleDownload from './modules/bundleDownload'
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  actions,
  getters,
  modules: {
    auth,
    headerParam,
    deliveryMonth,
    agency,
    advertiser,
    creativeReport,
    cpmCreativeReport,
    campaignReport,
    period,
    report,
    digestive,
    campaignList,
    campaignDeliveryStatus,
    creativeSetting,
    bundleDownload
  },
  plugins: [createPersistedState()]
})
